module.exports = __webpack_public_path__ + "img/about-cover.df538a17.jpg";